<template>
  <section class="panel" draggable="true" @click="closePanel()" :class="{ open: statePanel }">
  <div class="panel-container">
    <div class="panel-user" v-if="profile || profile">
      <router-link
        :to="'/user/' + getId"
        class="user-avatar"
        :style="{ backgroundImage: 'url(' + getAvatar + ')' }"
      >
        <!-- <div class="user-rate" v-if="profile.score">
            <img :src="require(`@/assets/images/emoji/${profile.score.level.icon}.svg`)" width="18" />
            <p>{{profile.score.level.name}}</p>
        </div> -->
      </router-link>
      <p class="user-name">{{ getName }}</p>
      <div class="button panel-add" @click="changeState('workplace')">
        <p>Создать</p>
      </div>

      <nav class="panel-menu">
        <ul class="panel-list">
          <router-link tag="li" class="panel-list__item" :to="{ name: 'user', params: {id: getId} }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.985 15.346c-3.868 0-7.17.585-7.17 2.927s3.281 2.948 7.17 2.948c3.867 0 7.17-.586 7.17-2.927s-3.282-2.948-7.17-2.948z" clip-rule="evenodd"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.429" d="M11.985 12.006A4.596 4.596 0 107.389 7.41a4.58 4.58 0 004.563 4.596h.033z" clip-rule="evenodd"/>
            </svg>
            <p>Мой профиль</p>
          </router-link>
          <router-link tag="li" class="panel-list__item" :to="{ name: 'friends' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.592 15.207c3.688 0 6.841.559 6.841 2.792 0 2.233-3.131 2.808-6.841 2.808-3.69 0-6.842-.554-6.842-2.788s3.13-2.812 6.842-2.812zM9.592 12.02a4.386 4.386 0 114.385-4.385 4.37 4.37 0 01-4.354 4.385h-.031z" clip-rule="evenodd"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.483 10.882A3.301 3.301 0 0019.32 7.62a3.3 3.3 0 00-2.762-3.256M18.596 14.732c1.55.231 2.634.775 2.634 1.895 0 .771-.51 1.271-1.335 1.584"/>
            </svg>
            <p>Мои друзья</p>
          </router-link>
          <router-link tag="li" class="panel-list__item" :to="{ name: 'friends' }">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.27 14.952l1.593-5.09 5.089-1.592-1.593 5.09-5.089 1.592z" clip-rule="evenodd"/>
              <circle cx="11.611" cy="11.611" r="9.611" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            </svg>
            <p>Ивенты</p>
          </router-link>
          <router-link tag="li" :to="{ name: 'places' }" class="panel-list__item">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.5 10.5a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z" clip-rule="evenodd"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 21c-1.199 0-7.5-5.102-7.5-10.437C4.5 6.387 7.857 3 12 3c4.142 0 7.5 3.387 7.5 7.563C19.5 15.898 13.198 21 12 21z" clip-rule="evenodd"/>
            </svg>
            <p>Места</p>
          </router-link>
          <router-link tag="li" :to="{ name: 'notifications' }" class="panel-list__item">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 17.848c5.64 0 8.248-.724 8.5-3.627 0-2.902-1.819-2.716-1.819-6.276C18.681 5.165 16.045 2 12 2S5.319 5.164 5.319 7.945c0 3.56-1.819 3.374-1.819 6.275.253 2.915 2.862 3.628 8.5 3.628z" clip-rule="evenodd"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.389 20.857c-1.364 1.515-3.492 1.533-4.87 0"/>
            </svg>
            <p>Уведомления</p>
            <span v-if="getNotifications && getNotifications.all">{{ getNotifications.all }}</span>
          </router-link>
          <li class="panel-list__item" @click="openMyEvents()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.093 9.404h17.823M16.442 13.31h.01M12.005 13.31h.009M7.558 13.31h.01M16.442 17.196h.01M12.005 17.196h.009M7.558 17.196h.01M16.044 2v3.29M7.965 2v3.29"/>
              <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.238 3.58H7.771C4.834 3.58 3 5.214 3 8.221v9.05C3 20.326 4.834 22 7.771 22h8.458C19.175 22 21 20.355 21 17.348V8.222c.01-3.007-1.816-4.643-4.762-4.643z" clip-rule="evenodd"/>
            </svg>

            <p>Мои события</p>
          </li>
          <!-- <li class="panel-list__item" @click="changeState('theme')">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.303 2.75H7.65c-3.012 0-4.901 2.134-4.901 5.154v8.146c0 3.02 1.88 5.154 4.9 5.154h8.648c3.025 0 4.905-2.134 4.905-5.154V7.904c.004-3.02-1.877-5.154-4.9-5.154z" clip-rule="evenodd"/>
                  <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.703 8.785a1.845 1.845 0 11-3.69.001 1.845 1.845 0 013.69-.001z" clip-rule="evenodd"/>
                  <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.207 14.951c-.923-.95-2.698-2.869-4.628-2.869-1.931 0-3.044 4.233-4.901 4.233-1.857 0-3.544-1.914-5.032-.687-1.488 1.226-2.896 3.733-2.896 3.733"/>
                </svg>
                <p>Сменить тему</p>
            </li> -->
          <router-link tag="li" :to="{ name: 'settings' }" class="panel-list__item">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M20.807 7.624l-.623-1.08a1.913 1.913 0 00-2.608-.705v0a1.904 1.904 0 01-2.61-.678 1.832 1.832 0 01-.255-.915v0a1.913 1.913 0 00-1.914-1.968h-1.254A1.904 1.904 0 009.64 4.191v0a1.913 1.913 0 01-1.913 1.886 1.83 1.83 0 01-.916-.257v0a1.913 1.913 0 00-2.608.705l-.669 1.099a1.913 1.913 0 00.696 2.608v0a1.913 1.913 0 010 3.314v0a1.904 1.904 0 00-.696 2.6v0l.632 1.088a1.913 1.913 0 002.609.742v0a1.895 1.895 0 012.6.696c.164.277.252.593.255.915v0c0 1.056.857 1.913 1.913 1.913h1.255c1.053 0 1.908-.85 1.912-1.904v0a1.904 1.904 0 011.914-1.913c.321.009.636.097.915.256v0a1.913 1.913 0 002.609-.695v0l.659-1.099a1.904 1.904 0 00-.696-2.608v0a1.904 1.904 0 01-.696-2.61c.166-.289.406-.529.696-.695v0a1.913 1.913 0 00.696-2.6v0-.008z" clip-rule="evenodd"/>
                <circle cx="12.175" cy="11.889" r="2.636" stroke="#130F26" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </svg>
              <p>Настройки</p>
          </router-link>
          <li class="panel-list__item panel-list__item_colored" @click="openCharityModal()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke-width="0" viewBox="0 0 24 24">
                <path fill="#130F26" d="M11.776 21.837a36.258 36.258 0 01-6.328-4.957 12.668 12.668 0 01-3.03-4.805C1.278 8.535 2.603 4.49 6.3 3.288A6.282 6.282 0 0112.007 4.3a6.291 6.291 0 015.706-1.012c3.697 1.201 5.03 5.247 3.893 8.787a12.67 12.67 0 01-3.013 4.805 36.58 36.58 0 01-6.328 4.957l-.25.163-.24-.163z" opacity=".4"/>
                <path fill="#130F26" d="M12.01 22l-.234-.163a36.316 36.316 0 01-6.337-4.957 12.667 12.667 0 01-3.048-4.805c-1.13-3.54.195-7.586 3.892-8.787a6.296 6.296 0 015.728 1.023V22zM18.23 10a.719.719 0 01-.517-.278.818.818 0 01-.167-.592c.022-.702-.378-1.341-.994-1.59-.391-.107-.628-.53-.53-.948.093-.41.477-.666.864-.573a.384.384 0 01.138.052c1.236.476 2.036 1.755 1.973 3.155a.808.808 0 01-.23.56.708.708 0 01-.537.213z"/>
              </svg>
              <p>Поддержка</p>
          </li>
          <li class="panel-list__item" @click="logout()">
              <img src="@/assets/images/icons/panel/icon_logout.svg" width="24" :style="{marginRight: '14px'}" />
              <p>Выйти</p>
          </li>
        </ul>
      </nav>
    </div>
    </div>
  </section>
</template>

<script>
import PushService from '@/config/firebase_push.js'
import charity from "@/data/main/charity"
const audio = new Audio(require('@/assets/audios/message.mp3'))

export default {
  name: 'Panel',
  sockets: {
      new_message (message) {
        this.notificationMessage(message)
      }
    },
  computed: {
    statePanel() {
      return this.$store.getters.panel;
    },
    getChat() {
      return this.$store.getters.getActiveChat
    },
    getNotifications() {
      return this.$store.getters.getUserNotifications;
    },
    profile() {
      return this.$store.getters.getAuthUser;
    },
    getAvatar() {
      let res =
        this.profile && this.profile.avatar
          ? this.profile.avatar
          : 'https://mir-s3-cdn-cf.behance.net/project_modules/disp/1bcdd944565991.5817acde24c51.gif';

      return res;
    },
    getName() {
      let res =
        this.profile && this.profile.firstname
          ? this.profile.firstname + ' ' + this.profile.lastname
          : this.profile.firstname + this.profile.lastname;
      return res;
    },
    getId() {
      let id = this.profile ? this.profile.id : this.profile.id;
      return id;
    },
    mutedChat() {
      let result = false;
      let user = this.profile;
      if (user.muted_chats) {
        result = this.getChat && user.muted_chats.find(chat => chat === this.getChat.id)
      }
      
      return result
    },
    webViewMode() {
      return this.$store.getters.webViewMode
    },
  },
  methods: {
    openCharityModal() {
      this.$store.dispatch('setModal', charity )
    },
    notificationMessage(message) {
      let user = this.profile;
      let chat = this.getChat;
      
      message.user = typeof message.user === 'string' ? JSON.parse(message.user) : message.user;
      !message.type && message.user.id !== user.id && (!chat || chat.id !== message.chat) && !this.mutedChat 
        ? (this.$socket.emit('view_chat', {chat_id: message.chat}), this.$store.dispatch('addMessage', message), audio.play())
        : '';
    },
    openMyEvents() {
      this.$router.push({name: 'events'});
      this.$store.dispatch('setTypeEvents', 'my_events')
    },
    closePanel() {
      this.$store.dispatch('changeState', { element: 'panel' })
    },
    async logout() {
      PushService.deleteToken()
      this.$socket.disconnect();
      this.webViewMode 
        ? await this.deleteDevice() 
        : (
          this.$store.dispatch('logout'),
          this.$router.push('/login'),
          this.$router.go()
        )
    },
    deleteDevice() {
      try {
          window.ReactNativeWebView 
              ? window.ReactNativeWebView.postMessage(JSON.stringify({method: 'logout'}))
              : '';
      } catch (error) {
          console.log(error)
      }
    },
    changeState(element) {
      this.$store.dispatch('changeState', { element });
    },
  }
};
</script>
